var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCuba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25e-05 2.78271H0V29.2175H6.25e-05V16.0002V2.78271Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 31.9999C24.8365 31.9999 31.9999 24.8365 31.9999 15.9999C31.9999 7.16342 24.8365 0 15.9999 0C7.16342 0 0 7.16342 0 15.9999C0 24.8365 7.16342 31.9999 15.9999 31.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0.000244141C10.7656 0.000244141 6.11843 2.51418 3.19937 6.40024H28.8007C25.8817 2.51412 21.2345 0.000244141 16.0001 0.000244141Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 32.0001C21.2346 32.0001 25.8817 29.4862 28.8007 25.6001H3.19937C6.11837 29.4862 10.7656 32.0001 16.0001 32.0001Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 16.0003C6.10352e-05 17.0962 0.110561 18.1664 0.320499 19.2003H31.6797C31.8896 18.1664 32.0001 17.0962 32.0001 16.0003C32.0001 14.9044 31.8896 13.8342 31.6797 12.8003H0.320499C0.110561 13.8342 6.10352e-05 14.9044 6.10352e-05 16.0003Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68633 4.68628C-1.56199 10.9346 -1.56199 21.0653 4.68633 27.3137C7.26839 24.7317 9.75164 22.2483 16 16L4.68633 4.68628Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47569 11.8262L7.51157 15.0146H10.8644L8.15213 16.9854L9.18801 20.1739L6.47569 18.2032L3.76326 20.1739L4.79938 16.9854L2.08701 15.0146H5.43963L6.47569 11.8262Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCuba);
export default __webpack_public_path__ + "static/media/flag_cuba.01d68a69cb12b69b961bffeb4226e8a4.svg";
export { ForwardRef as ReactComponent };